import * as React from 'react';
import FiltersBar from '../FiltersBar';
import LoadMore from '../LoadMore';
import NoResults from '../NoResults';
import { FiltersProvider } from '../../contexts/filters';
import { PostsProvider } from '../../contexts/posts';
import Search from '../filters/Search';
import Filters from '../Filters';
import PostsGrid from '../PostsGrid';
import PostsModal from '../PostsModal';
import Posts from '../Posts';
// import ResultCount from '../ResultCount';

const LayoutModalFilters = () => {
	return (
		<>
			<FiltersProvider>
				<FiltersBar>
					<Search />
					<Filters />
				</FiltersBar>
				<PostsProvider>
					<Posts>
						{/* <ResultCount foundPosts={0} /> */}
						<PostsGrid posts={[]} />
						<LoadMore page={0} maxNumPages={0} />
						<NoResults posts={[]} />
						<PostsModal posts={[]} />
					</Posts>
				</PostsProvider>
			</FiltersProvider>
		</>
	);
};

LayoutModalFilters.displayName = 'LayoutModalFilters';

export default LayoutModalFilters;
